import { Pipe, PipeTransform } from "@angular/core";
import { ServiceRequestOrderStatus } from "@gloria-public/order/domain/interfaces/cart.interface";
import { QRStatus } from "@gloria-public/questionnaire/domain/interfaces/questionnaire-response.interface";

@Pipe({ name: "srStatusIcon" })
export class SRStatusIconPipe implements PipeTransform {
  transform(status: ServiceRequestOrderStatus): string {
    const statusIconMap: { [key in ServiceRequestOrderStatus]: string } = {
      [ServiceRequestOrderStatus.RESULTS_AVAILABLE]: "check_circle",
      [ServiceRequestOrderStatus.ANALYSIS_COMPLETED]: "task_alt",
      [ServiceRequestOrderStatus.IN_ANALYSIS]: "biotech",
      [ServiceRequestOrderStatus.SAMPLE_RECEIVED]: "inventory_2",
      [ServiceRequestOrderStatus.IN_TRANSIT]: "local_shipping",
      [ServiceRequestOrderStatus.NOT_ORDERED]: "block",
      [ServiceRequestOrderStatus.SAMPLE_REJECTED]: "cancel",
      [ServiceRequestOrderStatus.ANALYSIS_FAILED]: "error",
      [ServiceRequestOrderStatus.ORDERED]: "hourglass_top",
    };

    return statusIconMap[status] || "help";
  }
}

@Pipe({ name: "srStatusColor" })
export class SRStatusColorPipe implements PipeTransform {
  transform(status: ServiceRequestOrderStatus): string {
    switch (status) {
      case ServiceRequestOrderStatus.RESULTS_AVAILABLE:
      case ServiceRequestOrderStatus.ANALYSIS_COMPLETED:
        return "#28a745";
      case ServiceRequestOrderStatus.IN_ANALYSIS:
      case ServiceRequestOrderStatus.ORDERED:
        return "#17a2b8";
      case ServiceRequestOrderStatus.SAMPLE_RECEIVED:
      case ServiceRequestOrderStatus.IN_TRANSIT:
        return "#ffc107";
      case ServiceRequestOrderStatus.SAMPLE_REJECTED:
      case ServiceRequestOrderStatus.ANALYSIS_FAILED:
        return "#dc3545";
      case ServiceRequestOrderStatus.NOT_ORDERED:
      default:
        return "#6c757d";
    }
  }
}

@Pipe({ name: "srStatusTooltip" })
export class SRStatusTooltipPipe implements PipeTransform {
  transform(status: ServiceRequestOrderStatus): string {
    const tooltipMap: { [key in ServiceRequestOrderStatus]: string } = {
      [ServiceRequestOrderStatus.RESULTS_AVAILABLE]: "page.home.serviceRequest.status.results_available",
      [ServiceRequestOrderStatus.ANALYSIS_COMPLETED]: "page.home.serviceRequest.status.analysis_completed",
      [ServiceRequestOrderStatus.IN_ANALYSIS]: "page.home.serviceRequest.status.in_analysis",
      [ServiceRequestOrderStatus.SAMPLE_RECEIVED]: "page.home.serviceRequest.status.sample_received",
      [ServiceRequestOrderStatus.IN_TRANSIT]: "page.home.serviceRequest.status.in_transit",
      [ServiceRequestOrderStatus.NOT_ORDERED]: "page.home.serviceRequest.status.not_ordered",
      [ServiceRequestOrderStatus.SAMPLE_REJECTED]: "page.home.serviceRequest.status.sample_rejected",
      [ServiceRequestOrderStatus.ANALYSIS_FAILED]: "page.home.serviceRequest.status.analysis_failed",
      [ServiceRequestOrderStatus.ORDERED]: "page.home.serviceRequest.status.ordered",
    };

    return tooltipMap[status] || "page.home.serviceRequest.status.unknown";
  }
}

@Pipe({ name: "qrStatusIcon" })
export class QRStatusIconPipe implements PipeTransform {
  transform(status: QRStatus | null | undefined): string {
    if (status) {
      const statusIconMap: { [key in QRStatus]: string } = {
        [QRStatus.IN_PROGRESS]: "assignment",
        [QRStatus.COMPLETED]: "assignment_turned_in",
      };

      return statusIconMap[status] || "assignment_add";
    } else {
      return "assignment_add";
    }
  }
}

@Pipe({ name: "qrStatusColor" })
export class QRStatusColorPipe implements PipeTransform {
  transform(status: QRStatus | null | undefined): string {
    if (status) {
      switch (status) {
        case QRStatus.IN_PROGRESS:
          return "#17a2b8";
        case QRStatus.COMPLETED:
          return "#28a745";
        default:
          return "#6c757d";
      }
    } else {
      return "#6c757d";
    }
  }
}

@Pipe({ name: "qrStatusTooltip" })
export class QRStatusTooltipPipe implements PipeTransform {
  transform(status: QRStatus | null | undefined): string {
    if (status) {
      const tooltipMap: { [key in QRStatus]: string } = {
        [QRStatus.IN_PROGRESS]: "page.home.questionnaire.status.in_progress",
        [QRStatus.COMPLETED]: "page.home.questionnaire.status.completed",
      };

      return tooltipMap[status] || "page.home.questionnaire.status.unknown";
    } else {
      return "page.home.questionnaire.status.not_started";
    }
  }
}
